<template>
  <Modal v-bind="$attrs" v-on="$listeners" @closed="closed">
    <div v-if="waiting" class="flex justify-center items-center loading-dialog2">
      <p class="text-gray-400 font-bold animate-pulse" v-if="waiting">{{ waiting }}</p>
    </div>
    <div class="main m-1">
      <!-- メール送信画面 -->
      <div v-if="isMail">
        <!-- 得意先名（得意先名＋支店名） -->
        <div class="text-lg font-bold text-blue-600 mb-5">
          {{ clientName }}
        </div>
        <!-- メールアドレス -->
        <div class="mb-3">
          <div class="text-blue-700 font-bold border-b border-blue-700 text-xs px-2 w-fit cursor-pointer" @click="openClientModal()">得意先メールマスタ編集</div>

          <div class="flex justify-between">
            <div class="text-xs font-bold mt-auto">送信先
              <span class="-top-0.5 ml-1 text-red-500"> * </span>
            </div>
            <PrimaryButton
              text="送信先追加"
              @click="mailAdd()"
              class="self-end py-0.5 bg-blue-50 text-blue-900 border-blue-900 m-1"
            >
              <Icon
                iconName="PlusCircle"
                slot="before"
                class="w-4 h-4 mr-0.5"
              />
            </PrimaryButton>
          </div>
          <div v-for="(m, i) in mail" :key="i">
            <div class="flex">
              <WmsSuggestInput
                :name="'mail' + i"
                :required="true"
                :selectionItems="mailList"
                :displayField="['clientName', 'clientName2', 'name', 'mail']"
                v-model="mail[i]"
                class="w-full"
                @selected="mailSelected2($event, i)"
              >
              <!-- 検索アイコン -->
              <template #addon-content>
                <Icon
                  iconName="Search"
                  :clickable="true"
                  class="w-5 h-5"
                  @click="openClientModal()"
                />
              </template>
              </WmsSuggestInput>
              <div class="m-auto ml-2">
                <TrashIcon class="text-gray-400 cursor-pointer hover:text-gray-500 active:text-gray-600 w-5 h-5" @click="mailDelete(i)"/>
              </div>
            </div>
          </div>
        </div>
        <!-- CC -->
        <div class="mb-3">
          <div class="flex">
            <div class="text-xs font-bold self-end">CC</div>
            <div @click="openUserArea=true" class="text-blue-700 border-b border-blue-700 cursor-pointer ml-5 self-end font-bold text-xs">担当エリア編集</div>
            <PrimaryButton
              text="CC追加"
              @click="ccAdd()"
              class="self-end bg-blue-50 text-blue-900 border-blue-900 m-1 ml-auto py-0.5"
            >
              <Icon
                iconName="PlusCircle"
                slot="before"
                class="w-4 h-4 mr-0.5"
              />
            </PrimaryButton>
          </div>
          <div v-for="(m, j) in cc" :key="j">
            <div class="flex">
              <WmsSuggestInput
                :name="'cc' + j"
                :required="true"
                :selectionItems="ccList"
                :displayField="['name', 'mail']"
                v-model="cc[j]"
                class="w-full"
              >
              </WmsSuggestInput>
              <div class="m-auto ml-2">
                <TrashIcon class="text-gray-400 cursor-pointer hover:text-gray-500 active:text-gray-600 w-5 h-5" @click="ccDelete(j)"/>
              </div>
            </div>
          </div>
        </div>
        <!-- BCC -->
        <div class="mb-3">
          <div class="flex justify-between">
            <div class="text-xs font-bold mt-auto">BCC（大野さんのメールアドレスです）</div>
          </div>
          <div class="">
            <WmsTextInput
              name="bcc"
              v-model="bcc"
            />
          </div>
        </div>
        <!-- 件名 -->
        <div class="mb-3">
          <WmsTextInput
            name="subject"
            caption="件名"
            :required="true"
            :error="subject==''"
            v-model="subject"
          />
        </div>
        <!-- 本文 -->
        <div class="mb-3">
          <WmsTextInput
            name="text"
            caption="本文"
            :multiline="true"
            :rows="15"
            :required="true"
            :error="text==''"
            v-model="text"
          />
        </div>

        <!-- 送信履歴は親画面の「得意先へ連絡」で確認する -->

        <PrimaryButton
          text="送信"
          @click="sendMail()"
          class="w-11/12 block m-auto"
        >
        </PrimaryButton>
      </div>

      <!-- FAX用紙出力画面 -->
      <div v-else>
        <PrimaryButton
          text="PDF出力"
          @click="pdfBtn()"
          :disabled="waiting?true:false"
          class="block ml-auto"
        >
          <LoadingIcon v-if="waiting" slot="before" class="h-4 w-4" />
          <Icon v-else iconName="Printer" slot="before" class="h-4 w-4" />
        </PrimaryButton>
        <div id="output" style="height: 100%;">
          <div style="font-size: xx-large; text-align: center;">
            FAX
          </div>

          <div style="display: flex; margin: 45px 2px; border: solid 1px gray; border-radius: 1rem;">
            <!-- 送信先 -->
            <div style="width: 50%;">
              <div style="font-weight: bold; border-bottom: 2px solid gray; width: 100%; text-align: center; padding: 5px 0px;">TO</div>
              <div style="padding-left: 15px; height: 193px; border-right: solid 1px gray;">
                <!-- 得意先名 -->
                <div style="border-bottom: 1px solid gray; width: 100%; font-weight: bold; min-height: 36px;">
                  <input
                    v-if="!waiting"
                    type="text"
                    class="border-0 w-full font-bold pb-0.5 pt-6"
                    v-model="zenkakuName1"
                  />
                  <div v-else style="width: 100%; padding: 1.5rem 0.75rem 0.125rem 0.75rem;">
                    {{ zenkakuName1 }}
                  </div>
                </div>

                <!-- 支店名 -->
                <div style="border-bottom: 1px solid gray; width: 100%; min-height: 36px;">
                  <input
                    v-if="!waiting"
                    type="text"
                    class="border-0 w-full pb-0.5"
                    v-model="senkakuName2"
                  />
                  <div v-else style="width: 100%; padding: 0.5rem 0.75rem 0.125rem 0.75rem;">
                    {{ senkakuName2 }}
                  </div>
                </div>

                <!-- 物件名 -->
                <div style="border-bottom: 1px solid gray; width: 100%; min-height: 36px;">
                  <input
                    v-if="!waiting"
                    type="text"
                    class="border-0 w-full pb-0.5"
                    v-model="siteName"
                  />
                  <div v-else style="width: 100%; padding: 0.5rem 0.75rem 0.125rem 0.75rem;">
                    {{ siteName }}
                  </div>
                </div>

                <!-- 担当者 -->
                <div style="border-bottom: 1px solid gray; width: 100%; min-height: 36px; margin-bottom: 30px; margin-top: auto;">
                  <WmsSuggestInput
                    v-if="!waiting"
                    name="faxPic"
                    :selectionItems="mailList"
                    :displayField="['clientName', 'clientName2', 'name']"
                    :clearable="true"
                    v-model="faxPic"
                    class="w-full fax-pic"
                    @selected="picSelected($event)"
                  >
                  <!-- 検索アイコン -->
                  <template #addon-content>
                    <Icon
                      iconName="Search"
                      :clickable="true"
                      class="w-5 h-5 mr-0.5"
                      @click="openClientModal()"
                    />
                  </template>
                  </WmsSuggestInput>
                  <!-- <input
                    v-if="!waiting"
                    type="text"
                    class="border-0 w-full pb-0.5"
                    v-model="faxPic"
                  /> -->
                  <div v-else style="width: 100%; padding: 0.5rem 0.75rem 0.125rem 0.75rem;">
                    {{ faxPic }}
                  </div>
                </div>
              </div>
              <div style="font-weight: bold; width: 100%; text-align: center; padding: 8px 0px; letter-spacing: 0.12em; border-top: 2px solid gray;">{{ today }}</div>
            </div>
            <!-- アポロ管財 -->
            <div style="width: 50%;">
              <div style="font-weight: bold; border-bottom: 2px solid gray; width: 100%; text-align: center; padding: 5px 0px;">FROM</div>
              <div style="display: flex; width: fit-content; margin: auto; font-size: 14px; height: 193px;">
                <div style="margin: auto;">
                  <img :src="logo" style="height: 35px; width: 224px; margin: auto; display: block;" />
                  <div style="display: flex; text-align: center; justify-content: center;">
                    <div style="margin-right: 13px;">{{ apolloInfo.zip }}</div>
                    <div>{{ apolloInfo.address }}</div>
                  </div>
                  <div style="display: flex; text-align: center; justify-content: center;">
                    <div style="margin-right: 13px;">TEL.{{ apolloInfo.tel }}</div>
                    <div>FAX.{{ apolloInfo.fax }}</div>
                  </div>
                  <div style="text-align: center;">業務サポート部 {{ userFullName }}</div>
                </div>
              </div>
              <div style="font-weight: bold; width: 100%; text-align: center; padding: 8px 0px; letter-spacing: 0.12em; border-top: 2px solid gray;">送信枚数  本葉を含めて   1枚</div>
            </div>
          </div>

          <!-- 建物管理部問い合わせ先 -->
          <div v-if="!waiting" class="">
            <div class="flex justify-between">
              <div class="text-xs font-bold self-end">建物管理部 担当者選択（この欄はPDFに表示されません、本文に適用されます。）</div>
              <div @click="openUserArea=true" class="text-blue-700 border-b border-blue-700 cursor-pointer ml-5 self-end font-bold text-xs">担当エリア編集</div>
              <PrimaryButton
                text="担当者追加"
                @click="ccAdd()"
                class="self-end bg-blue-50 text-blue-900 border-blue-900 m-1 py-0.5"
              >
                <Icon
                  iconName="PlusCircle"
                  slot="before"
                  class="w-4 h-4 mr-0.5"
                />
              </PrimaryButton>
            </div>
            <div v-for="(m, j) in cc" :key="j">
              <div class="flex">
                <WmsSuggestInput
                  :name="'cc' + j"
                  :required="true"
                  :selectionItems="ccList"
                  :displayField="'name'"
                  v-model="cc[j]"
                  class="w-full"
                >
                </WmsSuggestInput>
                <div class="m-auto ml-2">
                  <TrashIcon class="text-gray-400 cursor-pointer hover:text-gray-500 active:text-gray-600 w-5 h-5" @click="ccDelete(j)"/>
                </div>
              </div>
            </div>
          </div>

          <!-- 件名 -->
          <div style="text-align: center; margin: 70px 3px 15px 3px; font-size: large; border-bottom: solid 1px gray;">
            <input
              v-if="!waiting"
              type="text"
              class="border-0 w-full text-center"
              style="font-size: large;"
              v-model="subject"
            />
            <div v-else>
              {{ subject }}
            </div>
          </div>

          <!-- 本文 -->
          <div v-if="!waiting">
            <textarea
              name="text"
              class="border-0 w-98per rounded p-5 resize-none"
              style="height: 500px; line-height: 40px;"
              v-model="text"
            >
            </textarea>
          </div>
          <div v-else style="height: 500px; width: 95%; padding: 1.25rem;  white-space: pre-line; line-height: 40px;" class="w-full">
            {{ text }}
          </div>
        </div>
      </div>
    </div>

    <!-- メアドマスタモーダル -->
    <ClientMailMstModal
      v-model="clientModalShow"
      :open="clientModalShow"
      :selectable="true"
      @closeClientModal="closeClientModal"
    >
    </ClientMailMstModal>

    <!-- 建物管理部、勤怠課の担当エリア -->
    <UserAreaModal
      v-model="openUserArea"
      :open="openUserArea"
      @closed="openUserArea=false"
    />
  </Modal>
</template>

<script>
import Modal from '@components/Modal.vue'
import Icon from '@components/Icon.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import WmsTextInput from '@wmscomponents/WmsTextInput.vue'
import { TrashIcon } from '@vue-hero-icons/solid'
import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
import ClientMailMstModal from '../../Master/components/ClientMailMstModal.vue'
import UserAreaModal from '../../User/components/UserAreaModal.vue'
import LoadingIcon from '@assets/loading-circle.svg'
import * as clientMailManager from '@managers/clientMailManager'
import * as moment from 'moment'
import * as utils from '@libs/utils'
import * as dialogs from '@libs/dialogs'
import * as backend from '@libs/backend'
import * as constantsAKBS from '@libs/constantsAKBS'
import { APOLLO_INFO } from '@libs/constants'

export default {
  components: {
    Modal,
    Icon,
    PrimaryButton,
    WmsTextInput,
    TrashIcon,
    WmsSuggestInput,
    ClientMailMstModal,
    UserAreaModal,
    LoadingIcon
  },

	props: {
		open: {
			type: Boolean,
			default: false
		},
    // メール選択の場合
		isMail: {
			type: Boolean,
			default: false
		},
    // メインタスク（申請番号など）
    rp: {
      type: Object,
      default: () => ({})
    },
    // AKBS情報（清掃員名・入社日・退職日・清掃員コード）
    akbs: {
      type: Object,
      default: () => ({})
    },
    // 連絡する雇用指示1件（物件・作業内容・適用期間・行の状態）
    row: {
      type: Object,
      default: () => ({})
    }
	},

  data() {
    return {
      // ローディング
      waiting: '',
      // メールアドレス
      mail: [],
      // CC
      cc: [''],
      // BCC
      bcc: '',
      // メールタイトル
      subject: null,
      // 本文（メール、FAX）
      text: null,
      // 未来か否か
      isFuture: false,
      // 区分
      type: '入社',
      // 対象日
      date: ' 月 日',
      // メールマスタ画面
      clientModalShow: false,
      // メールリスト
      mailList: [],
      // CCリスト
      ccList: [
        { name: '', mail: '' }
      ],
      // 得意先担当者
      pics: [],
      // 自社情報
      apolloInfo: APOLLO_INFO,
      // FAX用得意先名
      zenkakuName1: '',
      // FAX用支店名
      senkakuName2: '',
      // 物件名
      siteName: '',
      // FAX用得意先の担当者
      faxPic: 'ご担当者様',
      // 検索を押した行
      // index: null,
      // アポロ管財ロゴ
      logo: `${utils.getSystemOrigin()}${process.env.VUE_APP_PUBLICPATH}images/apolloBlack.png`,
      // 担当エリア編集
      openUserArea: false
    }
  },

  computed: {
    /**
     * 見出しに出す得意先名（得意先名と支店名を1行にまとめる）
     */
    clientName() {
      return ((this.row.contactClient1 || '') + ' ' + (this.row.contactClient2 || '')).trim()
    },

    /**
     * ユーザー名（苗字）
     */
    userName() {
      return utils.getSurname(this.$store.getters.user.user_name)
    },

    /**
     * ユーザー名（フル）
     */
    userFullName() {
      return utils.deleteKana(this.$store.getters.user.user_name).replace('　', ' ')
    },

    /**
     * 本日日付
     */
    today() {
      return moment().format('YYYY年M月D日')
    }
  },

  watch: {
    async open() {
      if (this.open) {
        await this.getData()
      }
    },

    pics() {
      if (this.isMail) {
        const toClient = this.setToClientName()
        const pic = this.setToPic()
        const text = toClient + `\r\n${pic}\r\n\r\n`

        if (this.text && this.text.indexOf('お世話になっております。') > -1) {
          let add = this.text.substr(this.text.indexOf('お世話になっております。'))
          this.text = text + add
        }
      }
    },

    cc() {
      const text = '弊社建物管理部  ' + this.cc.join('、もしくは ') + ' '

      if (this.text && this.text.indexOf('お問い合わせにつきましては、') > -1 && this.text.indexOf('までご連絡ください。') > -1) {
        let before = this.text.substr(0, this.text.indexOf('お問い合わせにつきましては、') + 14)
        let add = this.text.substr(this.text.indexOf('までご連絡ください。'))
        this.text = before + text + add
      }
    }
  },

  methods: {
    /**
     * 得意先取得
     */
    async getData() {
      // 入社か、退職を判断（連絡する行の状態で決まる）
      // 新規追加の行だけが入社の連絡。既にある物件（作業終了・上書き）は退職の連絡になる
      this.type = this.isNewSite() ? '入社' : '退職'

      const target = this.targetDate()

      if (target) {
        this.date = moment(new Date(target)).format('YYYY年M月D日')

        // 対象日が過去か未来かを判断
        const today = Number(moment().format('YYYYMMDD'))
        this.isFuture = Number(target.replace(/-/g, '')) > today

        // 物件（連絡する雇用指示のもの）
        // 物件名は「物件名1＋改行＋物件名2」で持っている
        // 得意先がアートアベニュー（全角半角は問わない）のときは物件名2だけ、それ以外は物件名1だけを使う
        const names = (this.row.site || '').split(/\r?\n/).map(s => s.trim())
        const isArtAvenue = (utils.zenkaku(this.clientName) || '').includes('アートアベニュー')
        this.siteName = utils.zenkaku(isArtAvenue ? (names[1] || names[0] || '') : (names[0] || ''))

        // お客様担当者情報取得
        await this.getMailList()
        // 得意先名全角
        this.getZenkaku()
        // アポロ担当者リスト
        this.getCcList()

        // 本文をセット
        await this.setText()

        // メアドマスタから該当のデータを取得
        // this.getDataFromMailMaster()
      }

      if (!this.mail.length) {
        this.mail = ['']
      }
    },

    /**
     * 新規追加した物件か（契約内容変更で足した行は含めない）
     */
    isNewSite() {
      return !this.row.sequenceNumber && !this.row.isChangedTo
    },

    /**
     * 連絡の対象日（いつからの話か）
     * 新規追加は作業開始日、それ以外（退職の連絡）は作業終了日
     */
    targetDate() {
      return this.isNewSite() ? this.row.startDateWork : this.row.endDateWork
    },

    /**
     * 本文をセット
     */
    async setText() {
      let mailText = ''
      let mailText2 = ''

      // 件名
      this.subject = '【' + this.siteName + '】 清掃員' + this.type + 'のご連絡'

      let text = 'いたします。'
      let text2 = 'ます、'
      let text3 = '急なお知らせで、'
      if (!this.isFuture) {
        text = 'いたしました。'
        text2 = 'ました、'
        text3 = 'ご連絡が遅くなり、'
      }

      // メールの場合
      if (this.isMail) {
        const toClient = this.setToClientName()
        const pic = this.setToPic()
        mailText = toClient + `\r\n${pic}\r\n\r\n`

        mailText2 = '\r\n\r\nアポロ管財株式会社\r\nTEL.03-5438-8804（代）\r\nFAX.03-5438-8809'
      }

      // 作業内容は、連絡する雇用指示のものをそのまま使う
      const work = constantsAKBS.WORK_SELECTIONS.find(w => w.id == this.row.cdContentsWork)
      let employmentWorkTask = work ? work.name : ''

      // 雇用指示に作業内容が無いときは、本文に目印を入れて書き換えてもらう。
      // 知らせるのは本文を作り終えてから（途中で待つと、CCの差し込みが本文より先に走ってしまう）
      const noWork = !employmentWorkTask

      if (noWork) {
        employmentWorkTask = '（〇〇）'
      } else {
        if (employmentWorkTask == '日常清掃') {
          employmentWorkTask = '日常清掃員'
        }
        employmentWorkTask = '（' + employmentWorkTask + '）'
      }

      if (this.type == '入社') {
        // 入社
        const mailHire =
          mailText +

          `お世話になっております。アポロ管財業務サポート部でございます。\r\n` +

          `この度、${this.date}より ${employmentWorkTask}${this.akbs.nameStaff} が入社${text}\r\n` +

          `${text3}誠に申し訳ございません。\r\n` +

          `お問い合わせにつきましては、弊社建物管理部  〇〇までご連絡ください。\r\n` +

          'よろしくお願いいたします。' +

          mailText2

        this.text = mailHire
      } else {
        // 退職
        const mailRetire =
          mailText +

          `お世話になっております。アポロ管財業務サポート部でございます。\r\n` +

          `${this.siteName} で勤務しており${text2}\r\n` +

          `${employmentWorkTask}${this.akbs.nameStaff} ですが、一身上の都合により${this.date}付で退職${text}\r\n` +

          `${text3}誠に申し訳ございません。\r\n` +

          '後任が決まるまでの間、代行員にて対応させていただきます。\r\n' +

          'お問い合わせにつきましては、弊社建物管理部  〇〇までご連絡ください。\r\n' +

          'よろしくお願いいたします。' +

          mailText2
        this.text = mailRetire
      }

      // 本文ができてから知らせる
      if (noWork) {
        await dialogs.showWarningDialog('作業内容がありません', '作業内容（日常清掃員など）が雇用指示に入っていません。\r\n本文の（〇〇）を書き換えてください。')
      }
    },

    /**
     * 得意先名と支店名の間に改行
     */
    setToClientName() {
      let toClient = utils.zenkaku(this.row.contactClient1)
      if (this.row.contactClient2) {
        toClient += '\r\n' + utils.zenkaku(this.row.contactClient2)
      }
      return toClient
    },

    /**
     * 担当者名をセット
     */
    setToPic() {
      let pic = 'ご担当者様'
      if (this.pics && this.pics.length) {
        const res = Array.from(new Set(this.pics))
        const res2 = res.filter((r) => {
          return r
        })
        pic = res2.join('、　')
        if (!pic) {
          pic = 'ご担当者様'
        }
      }
      return pic
    },

    /**
     * メアド、お客様担当者マスタ取得
     */
    async getMailList() {
      this.mailList = []
      const res = await backend.searchData('mail/getData', { type: 1 })
      if (res.data.data && res.data.data.length) {
        this.mailList = res.data.data
      }
    },

    /**
     * 雇い入れCC（建物管理部担当者）リスト生成
     */
    async getCcList() {
      this.ccList = []
      let res = await backend.searchData('user/getUserList', { day: utils.getToday() })
      let userList = res.data.data
      if (userList && userList.length) {
        for (let i = 0; i < userList.length; i++) {
          const u = userList[i]
          // 建物管理部所属
          if (u.departmentName && u.departmentName.includes('建物管理') && u.userName && u.userName != '未定') {
            this.ccList.push({ name: utils.deleteSpace(utils.deleteKana(u.userName)), mail: u.eMailAdress, areas: u.areas })
          }
        }

        // 大野さんのメアド取得
        let ohno = userList.find((us) => {
          return us.id == '6244'
        })
        if (ohno) {
          this.bcc = ohno.eMailAdress
        }
      }

      const cc = []
      // 物件住所は雇用指示が持っている
      const address = this.row.siteAddress

      // 物件住所から担当エリアのスタッフをセット
      if (address && this.ccList.length) {
        let name = []
        this.ccList.forEach(row => {
          if (row.areas && row.areas.length) {
            for (let i = 0; i < row.areas.length; i++) {
              const a = row.areas[i]
              if (address.includes(a)) {
                name.push(row.name + 'さん')
                if (this.isMail) {
                  cc.push(row.name + ' ' + row.mail)
                } else {
                  cc.push(row.name)
                }
                break
              }
            }
          }
        })
        if (cc.length) {

          let msg = 'CC'
          if (!this.isMail) {
            msg = '建物管理部 担当者'
          }
          await dialogs.showInfoDialog(msg + 'に初期値設定', '物件住所エリアが担当の ' + name.join('、') + ' を初期値としてセットしました。')
        }
      }

      // メールの場合、2行目もしくは最後に上野様を追加
      const ueno = this.ccList.find((c) => {
        return (c.name.includes('上野') && c.name.includes('俊郎'))
      })
      if (this.isMail && ueno && ueno.mail) {
        const uenoMail = ueno.name + ' ' + ueno.mail
        if (cc.length) {
          if (!cc.includes(uenoMail)) {
            cc.push(ueno.name + ' ' + ueno.mail)
          }

        } else {
          cc.push('')
          cc.push(ueno.name + ' ' + ueno.mail)
        }
      }
      this.cc = cc
    },

    /**
     * メールアドレス追加
     */
    mailAdd() {
      this.mail.push('')
      this.pics.push('')
    },

    /**
     * cc追加
     */
    ccAdd() {
      this.cc.push('')
    },

    /**
     * メアド削除
     */
    mailDelete(i) {
      this.mail.splice(i, 1)
      this.pics.splice(i, 1)
      if (!this.mail.length) {
        this.mailAdd()
      }
    },

    /**
     * ccメアド削除
     */
    ccDelete(i) {
      this.cc.splice(i, 1)
      if (!this.cc.length) {
        this.ccAdd()
      }
    },

    /**
     * メール選択（ダイアログから）
     * @param row 選択したデータ
     * @param idx インデックス
     */
    mailSelected(row) {
      if (row && Object.keys(row).length) {
        // メアド追加
        let arr = []
        if (this.mail) {
          arr = utils.clone(this.mail)
          if (!arr) {
            arr = []
          }
        }
        arr.push(row.mail)
        this.mail = arr.filter((a) => {
          return a
        })

        // 担当者追加
        let arr2 = []
        if (this.pics) {
          arr2 = utils.clone(this.pics)
          if (!arr2) {
            arr2 = []
          }
        }
        arr2.push(row.name)
        this.pics = arr2.filter((a) => {
          return a
        })
      }
    },

    /**
     * メール選択（入力フォームから）
     * @param row 選択したデータ
     * @param i インデックス
     */
    mailSelected2(row, i) {
      if (i >= this.pics.length) {
        this.pics.push(row.name)
      } else {
        this.pics.splice(i, 1, row.name)
      }
    },

    /**
     * メール送信
     */
    async sendMail() {
      let validate = await this.validation()
      if (!validate) {
        return
      }

      const cc = this.cc.filter((c) => {
        return c
      })

      if (!cc || !cc.length) {
        const d1 = await dialogs.showConfirmDialog('CCの宛先確認', 'CCの宛先がありませんが、よろしいでしょうか？')
        if (d1 != 'YES') {
          return
        }
      }

      if (!this.bcc) {
        const d1 = await dialogs.showConfirmDialog('BCCの宛先確認', 'BCCに大野さんのメールがないですが、よろしいでしょうか？')
        if (d1 != 'YES') {
          return
        }
      }

      const dialog = await dialogs.showConfirmDialog('送信してよろしいでしょうか？', '')
      if (dialog != 'YES') {
        return
      }

      this.waiting = 'Sending...'

      const address = this.mail.filter((m) => {
        return m
      })

      let bcc = []
      if (this.bcc) {
        bcc = [this.bcc]
      }

      const param = {
        to: address,
        cc,
        bcc,
        subject: this.subject,
        text: this.text,
        staff: this.userName,
      }

      // postData は送信に失敗すると throw するので、失敗も履歴に残してから知らせる
      try {
        await backend.postData('employment/sendmail', param)
        await dialogs.showSuccessDialog('送信しました。')

        // 履歴を保存
        await this.saveHistory('成功', param)

        // 送信できたら閉じる（履歴は親画面の「得意先へ連絡」で確認する）
        this.$emit('close')
      } catch (e) {
        console.log(e)
        await this.saveHistory('失敗', param)
        await dialogs.showErrorDialog('送信失敗しました', e.message || e)
      } finally {
        this.waiting = ''
      }
    },

    /**
     * 結果を履歴に保存（メール送信・FAX出力の両方から呼ぶ）
     * @param {String} sendStatus 成功／失敗
     * @param {Object} param 送信・出力した内容
     */
    async saveHistory(sendStatus, param) {
      param.sendStatus = sendStatus
      param.requestNo = this.rp.requestNo
      param.date = moment().format('YYYY/MM/DD HH:mm')
      // メールかFAXかを残す
      param.method = this.isMail ? 'メール' : 'FAX'
      // どの物件の、どの得意先へ、何の連絡をしたのかを残す（親画面の履歴で突き合わせる）
      // type は保存側で使っている項目名なので、連絡の種類は contactType で持つ
      param.cdSite = this.row.cdSite
      param.site = this.siteName
      param.client = this.clientName
      param.contactType = this.type
      param.targetDate = this.targetDate()

      const his = await clientMailManager.historyRegister(this, param)
      if (!his) {
        await dialogs.showErrorDialog('送信履歴保存エラー', '送信履歴保存中にエラーが発生しました。')
      }

      // 親画面の「得意先へ連絡」で履歴を出し直してもらう
      this.$emit('sent')
    },

    /**
     * チェック処理
     */
    async validation() {
      if (this.isMail) {
        if (!this.mail || !this.mail.length) {
          await dialogs.showErrorDialog('メールアドレス未入力', 'メールアドレスを入力してください。')
          return false
        }
        const address = this.mail.filter((m) => {
          return m
        })
        if (!address || !address.length) {
          await dialogs.showErrorDialog('メールアドレス未入力', 'メールアドレスを入力してください。')
          return false
        }
        if (!this.subject) {
          await dialogs.showErrorDialog('件名未入力', '件名を入力してください。')
          return false
        }
      }
      if (!this.text) {
        await dialogs.showErrorDialog('本文未入力', '本文を入力してください。')
        return false
      } else if (this.text.indexOf('〇〇') > -1) {
        await dialogs.showErrorDialog('本文に○○があります', '本文を完成させてください。')
        return false
      }
      return true
    },

    /**
     * 得意先名全角取得
     */
    getZenkaku() {
      this.zenkakuName1 = utils.zenkaku(this.row.contactClient1 || '')
      this.senkakuName2 = utils.zenkaku(this.row.contactClient2 || '')
    },

    /**
     * 担当者選択
     */
    picSelected(e) {
      this.faxPic = e.name || 'ご担当者様'
    },

    /**
     * PDF出力
     */
    async pdfBtn() {
      let validate = await this.validation()
      if (!validate) {
        return
      }
      this.waiting = 'PDF生成中...'
      await utils.wait(500)
      try {
        const param = {
          html: document.querySelector("#output").outerHTML
        }
        const res = await backend.postBlob2('employment/pdf', param)
        const uint8Array = res.data
        const blob = new Blob([uint8Array], { type : "application/pdf" })
        const url = URL.createObjectURL(blob)

        // 別タブで開く
        window.open(url, '_blank')

        // 必要なら後で解放
        setTimeout(() => URL.revokeObjectURL(url), 10000) // 10秒後に解放
        this.waiting = ''

        // 履歴を保存（メールと同じく、いつ誰がどの得意先へ出したかを残す）
        // FAXは用紙を出しただけで送ったかまでは分からないため「出力済」とする
        await this.saveHistory('出力済', {
          to: this.row.contactFax ? [this.row.contactFax] : [],
          cc: this.cc.filter(c => c),
          bcc: [],
          subject: this.subject,
          text: this.text,
          staff: this.userName,
        })

        // 出力できたら閉じる
        this.$emit('close')
      } catch (e) {
        console.log(e)
        alert(e)
        this.waiting = ''
      }
    },

    /**
     * メアドマスタモーダルopen
     */
    openClientModal() {
      this.clientModalShow = true
    },

    /**
     * メアドマスタモーダルclose
     * @param row 反映するデータ
     */
    closeClientModal(row) {
      if (row) {
        if (this.isMail) {
          this.mailSelected(row)
        } else {
          this.picSelected(row)
        }
      }
      this.clientModalShow = false
    },

    /**
     * 閉じる
     */
    closed() {
      // ローディング
      this.waiting = ''
      // メールアドレス
      this.mail = []
      // CC
      this.cc = ['']
      // BCC
      this.bcc = ''
      // メールタイトル
      this.subject = null
      // メール本文
      this.text = null
      // 未来か否か
      this.isFuture = false
      // 区分
      this.type = '入社'
      // 対象日
      this.date = ' 月 日'
      // メールマスタ画面
      this.clientModalShow = false
      // メールリスト
      this.mailList = []
      // 得意先担当者
      this.pics = []
      // FAX用得意先名
      this.zenkakuName1 = ''
      // FAX用支店名
      this.senkakuName2 = ''
      // 物件名
      this.siteName = ''
      // FAX用得意先の担当者
      this.faxPic = 'ご担当者様'
    }
  }
}
</script>
<style scoped>
.main {
  min-width: 700px;
}

.fax-pic >>> input[type=text] {
  border: none;
  padding-top: 0.55rem !important;
  padding-bottom: 0.125rem !important;
  font-size: medium !important;
}
</style>